import { useCallback } from 'react';

import { SearchInput } from '~/ui/molecules/SearchInput';

import {
  type FilterDraftValue,
  type UniversalBuiltInDrawerFieldConfig,
} from '../../types';

type TextDrawerFieldConfig = Extract<
  UniversalBuiltInDrawerFieldConfig,
  { input: 'text' }
>;

type TextDrawerFieldControlProps = {
  readonly fieldConfig: TextDrawerFieldConfig;
  readonly onChange: (next?: FilterDraftValue) => void;
  readonly testId: string;
  readonly value: string;
};

function toTextDraftValue(raw: string, maxLength?: number) {
  const trimmed = raw.trim();
  const next = maxLength === undefined ? trimmed : trimmed.slice(0, maxLength);

  return next === '' ? undefined : next;
}

export function TextDrawerFieldControl({
  fieldConfig,
  value,
  onChange,
  testId,
}: TextDrawerFieldControlProps) {
  const handleChange = useCallback(
    (raw: string) => {
      const next = toTextDraftValue(raw, fieldConfig.maxLength);
      const current = value === '' ? undefined : value;

      if (next !== current) {
        onChange(next);
      }
    },
    [fieldConfig.maxLength, onChange, value],
  );

  return (
    <SearchInput
      className="w-full"
      debounceTime={300}
      onFocus={() => undefined}
      placeholder={fieldConfig.placeholder ?? ''}
      startAdornment={null}
      testId={testId}
      value={value}
      onChange={handleChange}
    />
  );
}
